<template>
  <div>
    <div style="display: flex; justify-content: space-between">
      <div class="zjz_c">
        <div v-if="competeResultState.code === 2 || competeResultState.code === 3">
          <div style="text-align: center">
            <h2
              style="
                color: red;
                border: 1px solid #e6e6e6;
                padding: 30px 0;
                margin: 40px auto;
                width: 600px;
              "
            >
              <B>{{ competeResultState.msg }}</B>
            </h2>
          </div>
        </div>
        <div
          v-if="competeResultState.code !== 2"
          :style="status === '2' ? 'height: 4.5vw' : 'height: 9.083vw'"
        >
          <div class="t2" v-if="status === '1'">
            <span>{{ prefix }}</span>
            <span class="box" v-if="day">{{ day }}</span>
            <span v-if="day">天</span>
            <span class="box" v-if="hour">{{ hour }}</span>
            <span v-if="hour">时</span>
            <span class="box">{{ minutes }}</span>
            <span>分</span>
            <span class="box">{{ seconds }}</span>
            <span>秒</span>
          </div>
          <div
            style="text-align: center"
            v-if="status === '2' && competeResultState.code !== 3"
          >
            <h2 style="color: #a5a5a5; font-size: 32px">
              <B>竞价已结束</B>
            </h2>
            <div
              style="color: white; font-size: 16px"
              v-if="packs.dealRule == '2' && theSame"
            >
              <B>本包组需要抽签确定成交供应商,抽签将在所有包组竞价结束后在线公开进行</B>
            </div>
          </div>

          <div class="d-flex t3" v-if="status === '1'">
            <div :class="strokeWidth > 100 - percent1 ? 'arrow red' : 'arrow'">
              <p class="text-left mb-0" style="color: #98a2b6">
                竞价时长：{{ packs.duration }} 分钟
              </p>
              <a-progress
                strokeColor="#f5f5f5"
                :strokeWidth="strokeWidth"
                :percent="percent1"
                :show-info="false"
              />
            </div>
            <div class="countDown red" v-if="packs.jingjiaWay == '1'">
              <p class="text-left mb-0" style="color: #98a2b6">
                倒计时阶段
                <span v-if="packs.countDown">({{ packs.countDown }} 分钟)</span>
              </p>
              <a-progress
                strokeColor="#f5f5f5"
                style="width: 200px"
                :strokeWidth="strokeWidth"
                :percent="percent2"
                :show-info="false"
              />
            </div>
          </div>
          <div
            v-if="serveDate && status === '1'"
            class="text-center"
            style="color: #bac2d2"
          >
            当前服务器时间 {{ serveDate }}
          </div>
        </div>
        <div>
          <div class="code">
            <div>
              我的竞价编号为：
              <span style="color: #fff800; font-size: 16px">
                <B>{{ competeNo }}</B>
              </span>
            </div>
            <div v-if="status === '1'">
              <span style="margin-right: 5px; color: #98a2b6"
                >报价记录实时自动刷新。如遇问题请手动刷新</span
              >
              <a-button
                style="background: #304879 !important"
                @click="onFresh"
                :size="small"
                ghost
              >
                手动刷新
              </a-button>
            </div>
          </div>
          <div
            class="table-preant"
            :style="
              status === '2' && competeResultState.code === 3
                ? 'height:calc(100vh - 17vw);'
                : status === '2'
                ? 'height:calc(100vh - 12vw);'
                : ''
            "
          >
            <img class="img" :src="$_c + 'img/jjz_img/icon1.svg'" />
            <img class="img" :src="$_c + 'img/jjz_img/icon1.svg'" />
            <img class="img" :src="$_c + 'img/jjz_img/icon1.svg'" />
            <img class="img" :src="$_c + 'img/jjz_img/icon1.svg'" />
            <div class="table-preant-item scrollbar-zdy">
              <table class="table">
                <thead>
                  <tr>
                    <td>竞价人</td>
                    <td>竞价人编号</td>
                    <td>报价</td>
                    <td>报价时间</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(it, index) in data" :key="index">
                    <td>
                      <span v-if="status === '1'">
                        <span
                          v-if="
                            myData.length != 0 && myData[0].supplierId == it.supplierId
                          "
                          class="me"
                        >
                          我
                        </span>
                        {{ it.supplierName }}
                      </span>
                      <span v-else style="padding-left: 10px">
                        <span
                          v-if="
                            myData.length != 0 && myData[0].supplierId == it.supplierId
                          "
                          class="me"
                        >
                          我
                        </span>
                        {{ it.supplierName2 }}
                      </span>
                    </td>
                    <td>{{ it.competeNo }}</td>
                    <td>
                      <span v-if="status === '1'">
                        {{ it.price_one.toLocaleString("en-US") }}
                      </span>
                      <span v-else>
                        <span v-if="it.price">
                          {{
                            packs.offerType == "1"
                              ? it.price.toLocaleString("en-US")
                              : (it.price * 100).toFixed(2).toLocaleString("en-US")
                          }}
                          {{ getPriceUnitText }}
                        </span>
                      </span>
                    </td>
                    <td>{{ it.priceDate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="data.length == 0"><a-empty description="无人报价" /></div>
          </div>
        </div>
      </div>
      <div class="zjz_r">
        <a-divider style="opacity: 0.2; margin: 0.5vw 0" />
        <a-descriptions :column="1" title="竞价方式">
          <a-descriptions-item
            :label="packs.jingjiaWay === '1' ? '自由竞价' : '单轮竞价'"
          >
            {{ packs.jingjiaType === "1" ? "竞高价" : "竞低价" }}
            <!--竞价说明 -->
            <BiddingDescription :way="packs.jingjiaWay" />
          </a-descriptions-item>
          <a-descriptions-item
            :label="packs.jingjiaType === '1' ? '最低限价' : '最高限价'"
          >
            <span v-if="packs.offerType != '1'">
              按{{ packs.offerType == "1"?"报价":packs.offerType == "2"?"折扣率":"下浮率" }}报价
              <span v-if="packs.priceStart">
                （不能{{ packs.jingjiaType === "1" ? "低于" : "高于" }}
                {{ packs.priceStart }}%）
              </span>
            </span>
            <span v-else-if="packs.priceStart">
              {{ packs.priceStart }} {{ getPriceUnitText }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="竞价开始时间">
            {{ startDate2 }}
          </a-descriptions-item>
          <a-descriptions-item label="竞价时长">
            {{ packs.duration }} 分钟 &nbsp;&nbsp;&nbsp;<span v-if="packs.countDown">
              倒计时长
              <span class="color-main"> {{ packs.countDown }}</span>
              分钟
            </span>
          </a-descriptions-item>

          <a-descriptions-item>
            <div v-if="packs.dealRule == '1'" style="color: red">
              如有相同{{ packs.jingjiaType === "1" ? "最高" : "最低" }}报价，先报价者成交
            </div>
            <div v-else style="color: red">
              如有相同{{
                packs.jingjiaType === "1" ? "最高" : "最低"
              }}报价，抽签决定成交供应商
            </div>
          </a-descriptions-item>
        </a-descriptions>

        <a-divider style="opacity: 0.2" />
        <div class="Operation_area">
          <div v-if="status === '1' && myData.length == 0">
            <div class="t1">
              <span v-if="packs.offerType == '1'">
                <span v-if="packs.jingjiaType === '1'">最低限价：</span>
                <span v-else-if="packs.jingjiaType === '2'">最高限价：</span>
              </span>
              <span v-if="packs.offerType != '1'">
                报价范围：
                <span v-if="packs.priceStart">
                  <span v-if="packs.jingjiaType === '1'">
                    {{ packs.priceStart }}% - 100%
                  </span>
                  <span v-else-if="packs.jingjiaType === '2'">
                    0% - {{ packs.priceStart }}%
                  </span>
                </span>
                <span v-else>0% - 100%</span>
              </span>
              <span v-else-if="packs.priceStart">
                {{ packs.priceStart }} {{ getPriceUnitText }}
              </span>
            </div>
            <div class="t2">
              <div class="btn" v-if="packs.offerType === '1'">
                <a-icon
                  v-if="packs.jingjiaType === '1'"
                  type="minus"
                  style="color: white"
                  @click="onReduce"
                />
                <a-icon
                  v-if="packs.jingjiaType === '2'"
                  type="plus"
                  style="color: white"
                  @click="onAdd"
                />
              </div>
              <div class="btn" style="margin-right: 15px" v-else></div>

              <a-input-number
                :min="0"
                :default-value="0"
                v-model="myPrice"
                v-if="packs.offerType === '1'"
                @keyup.enter.native="submit"
              />
              <a-input-number
                :min="0"
                :max="100"
                :default-value="0"
                :precision="2"
                v-model="myPrice"
                v-else
                @keyup.enter.native="submit"
              />

              <div class="btn" v-if="packs.offerType === '1'">
                <a-icon
                  v-if="packs.jingjiaType === '1'"
                  type="plus"
                  style="color: white"
                  @click="onAdd"
                />
                <a-icon
                  v-if="packs.jingjiaType === '2'"
                  type="minus"
                  style="color: white"
                  @click="onReduce"
                />
              </div>
              <div class="btn" v-else>
                <a-icon type="percentage" style="color: red" />
              </div>
            </div>
            <div class="t3">
              <a-button type="primary" :loading="loading" @click="submit">
                提交报价
              </a-button>
            </div>
          </div>
          <div
            v-else-if="status !== '1'"
            style="text-align: center; font-size: 1vw; font-weight: bold"
          >
            截止报价
          </div>
          <div v-else style="text-align: center; font-size: 1.2vw; font-weight: bold">
            您已提交报价
          </div>
          <div class="t3" v-if="packs.jingjiaDetail === '1'">
            <a-button
              class="mr-1"
              @click="addSubject"
              v-if="status === '1' && myData.length == 0"
            >
              填报详细报价
            </a-button>
            <a-button @click="showSubjectDetail"> 预览详细报价 </a-button>
          </div>
        </div>
        <a-divider style="opacity: 0.2" />
        <div class="flex-left" v-if="packs.quotationConfirm == '1'">
          <SingleUploadSelector
            :referId="packId + currentSupplierId"
            :deleteVisabled="myData.length > 0"
            :status="status"
            ref="singleUploadSelector"
            value="license"
            configKey="supplier_process_confirm"
            @uploadSuccess="uploadSelectorChange"
          />
        </div>
        <div>
          <AddSubject
            ref="addSubject"
            :visible="addSubjectVisible"
            :stopDate="stopDate"
            :bz="bz"
            :offerType="packs.offerType"
            :offerTypeText="getPriceUnitText"
            :serveDate="serveDate"
            @cancel="cancel"
          ></AddSubject>
          <BidSubjectDetail
            ref="bidSubjectDetail"
            :visible="showSubjectVisible"
            :bz="bz"
            :offerType="packs.offerType"
            :offerTypeText="getPriceUnitText"
            @cancel="cancel"
          />
          <BidSubject
            ref="sbt"
            :visible="bidSubjectVisible"
            @cancel="cancel"
          ></BidSubject>
        </div>
        <!--抽签弹框按钮 -->
        <CompetitiveResultDraw ref="draw" @reSatrtDraw="reSatrtDraw"></CompetitiveResultDraw>
        <div style="position: absolute; bottom: 1vw; width: 18.3vw">
          <a-button
            class="mb-1"
            type="primary"
            block
            v-if="status !== '1' && packs.dealRule == '2' && theSame"
            @click="openDraw"
            >进入抽签环节</a-button
          >
          <a-button type="danger" block @click="back"> 退出竞价大厅 </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import qs from "qs";
import CountDown from "@/components/CountDown/CountDown";
import BidSubject from "../product/BidSubject";
import moment from "moment";
import BidSubjectDetail from "../product/BidSubjectDetail.vue";
import AddSubject from "../product/AddSubject";
import SingleUploadSelector from "@/components/selector/SingleProcessUploadSelector";
import BiddingDescription from "./BiddingDescription.vue";
import CompetitiveResultDraw from "./CompetitiveResultDraw";
export default {
  name: "newSingleCompete",
  props: {
    packId: {
      type: String,
      required: true,
    },
    selectPackIndex: {
      default: 0,
    },
  },
  components: {
    CountDown,
    BidSubject,
    moment,
    BidSubjectDetail,
    AddSubject,
    SingleUploadSelector,
    BiddingDescription,
    CompetitiveResultDraw,
  },
  computed: {
    getPriceUnitText() {
      return this.packs.offerType == "1" ? "元" : "%";
    },
    getPriceText() {
      return this.packs.offerType == "1"
        ? "报价"
        : this.packs.offerType == "2"
        ? "折扣率"
        : "下浮率";
    },
  },
  data() {
    return {
      small: "small",
      theSame: false, //相同报价
      fileLength: 0,
      data: [],
      myData: [],
      packs: {},
      packsList: [],
      myPrice: "",
      competeNo: "",
      startDate: "",
      startDate2: "",
      serveDate: "", //服务器时间
      serveDateTimer: "",
      currentSupplierId: "",
      lastedData: "",
      competeType: "",
      stopDate: 0, //最终结束时间
      status: "", //  1竞价中，2已结束
      reconInv: "",
      prefix: "离竞价结束还有",
      strokeWidth: 20,
      min: 0,
      max: 1000000000,
      bidSubjectVisible: false,
      competeResultState: "",
      day: "",
      hour: "",
      minutes: "",
      seconds: "",
      countDownTimer: "",
      modal2Visible: false,
      processTimer: "",
      commonResultDate: "", //常规竞价结束时间
      percent1: 0,
      percent2: 0,
      openDate: 0, //竞价开始时间
      dateDisparity: 0, //时间差距
      loading: false,
      addSubjectVisible: false,
      showSubjectVisible: false,
      bz: "", //备注
      socketUrl: process.env.VUE_APP_API_SERVER + "/webSocket",
      socket: "",
      stompClient: "",
      isFreshed: false,
    };
  },
  watch: {
    /* status: {
      handler(val) {
        if (val == "2") {
          //时间到了将转盘展示
          // this.$refs.draw.initmodel();
        }
      },
    },
    packId: {
      handler(val) {
        this.initPacksInfo();
      },
    }, */
  },
  created() {
    this.initPacksInfo();
  },
  methods: {
    setModal1Visible(modal1Visible) {
      this.modal1Visible = modal1Visible;
    },
    onAdd() {
      if (this.myPrice) {
        this.myPrice = this.myPrice + 1;
      } else {
        this.myPrice = 1;
      }
    },
    onReduce() {
      if (this.myPrice) {
        this.myPrice = this.myPrice - 1;
      } else {
        this.myPrice = 1;
      }
    },
    initPacksInfo() {
      let that = this;
      this.$http
        .get("/api/v1/supplier/singleCompete/initPackInfo/" + this.packId)
        .then(function (res) {
          if (res.serveDate) {
            that.serveDate = res.serveDate.replace(new RegExp(/-/gm), "/"); //读取服务器时间
          }
          if (res.result.extras.openTime) {
            that.startDate = res.result.extras.openTime.replace(new RegExp(/-/gm), "/");
            that.startDate2 = res.result.extras.openTime.replace(new RegExp(/-/gm), "/");
            that.startDate2 = moment(new Date(that.startDate2)).format(
              "YYYY/MM/DD HH:mm"
            );
          }
          if (res.commonResultDate) {
            that.commonResultDate = res.commonResultDate.replace(new RegExp(/-/gm), "/");
          }
          if (res.stopDate) {
            that.stopDate = res.stopDate.replace(new RegExp(/-/gm), "/");
          }
          if (res.openDate) {
            that.openDate = res.openDate.replace(new RegExp(/-/gm), "/");
          }
          that.dateDisparity = new Date(that.serveDate).getTime() - new Date().getTime();
          that.packs = res.result;
          that.currentSupplierId = res.supplierId; //供应商ID
          that.competeNo = res.result.extras.competeNo; //竞价编号
          that.competeType = that.packs.jingjiaType;
          that.competeResultState = res.competeResultState; //竞价结果状态
          if (that.packs.countDown === "0") {
            that.packs.countDown = "";
          }
          if (that.packs.jingjiaType === "2") {
            that.max = that.packs.priceStart; //报价所需要的最大值
          } else if (that.packs.jingjiaType === "1") {
            that.min = that.packs.priceStart; //最小值
          }
          if (that.competeResultState.code !== 2) {
            //避免延迟显示
            that.getCountDownDate();
            that.onProcess();
            that.serveDateTimer = setInterval(that.getServerDate, 1000); // 动态改变服务器时间
            that.countDownTimer = setInterval(that.getCountDownDate, 1000); // 倒计时
            that.processTimer = setInterval(that.onProcess, 1000); //进度条倒计时
            // that.getCompeteInfo();//加载竞价数据
            that.initWebSocket(); //初始化webSocket
          }
        });
    },
    onFresh() {
      if (!this.isFreshed) {
        let that = this;
        this.$http
          .get("/api/v1/supplier/socket/get_process_list.json?packsId=" + this.packId+ "&isEnd=" +
            false)
          .then(function (res) {
            that.sysWarning("刷新成功");
            that.isFreshed = true;
            let freshTimer = setTimeout(function () {
              that.isFreshed = false;
              clearTimeout(freshTimer);
            }, 5000);
          });
      } else {
        that.sysWarning("刷新太频繁，请5s后再试!");
      }
    },
    getServerDate() {
      //动态改变服务器时间
      // this.serveDate = moment(new Date(new Date(this.serveDate).getTime() + 1000)).format('YYYY/MM/DD HH:mm:ss')
      this.serveDate = moment(new Date().getTime() + this.dateDisparity).format(
        "YYYY/MM/DD HH:mm:ss"
      );
    },
    getCountDownDate() {
      var date =
        new Date(this.commonResultDate).getTime() - new Date(this.serveDate).getTime();
      if (date > 0) {
        // **************************************常规倒计时********************************************************
        this.status = "1";
        this.prefix = "离竞价结束还有";
        var days = Math.floor(date / 1000 / 60 / 60 / 24); // 从这里开始
        var daysmod = date - days * 24 * 60 * 60 * 1000;
        var hours = Math.floor(daysmod / 1000 / 60 / 60);
        var hoursmod = date - days * 24 * 60 * 60 * 1000 - hours * 1000 * 60 * 60;
        var minutes = Math.floor(hoursmod / 1000 / 60);
        var minutesmod =
          date -
          days * 24 * 60 * 60 * 1000 -
          hours * 1000 * 60 * 60 -
          minutes * 1000 * 60;
        var seconds = Math.floor(minutesmod / 1000); // 到这里结束，是将总毫秒转化成对应天数+小时数+分钟数+秒数的转换方法

        if (hours === 0 && hours === 0) {
          this.day = "";
          this.hour = "";
        } else {
          this.day = days;
          this.hour = hours;
        }
        this.minutes = minutes;
        this.seconds = seconds;
      } else {
        this.percent2 = 100;
        this.status = "2";
        // this.getCompeteInfo()
        this.getProcessList(true);
        // 清除定时器
        clearInterval(this.getServerDate);
        clearInterval(this.countDownTimer);
      }
    },
    onMessageReceived(payload) {
      // 接收到消息并对消息做处理
      var list = JSON.parse(payload.body);
      this.theSame = list.theSame; //相同报价出现
      var dataList = list.data;
      if (list.stopTime) {
        //获取最新的结束时间
        this.stopDate = list.stopTime.replace(/-/g, "/");
      }
      if (list.serverDate) {
        this.serveDate = list.serverDate.replace(new RegExp(/-/gm), "/"); //读取服务器时间
      }
      this.data = [];
      if (dataList && dataList.length > 0) {
        this.lastedData = dataList[0];
        for (let i = 0; i < dataList.length; i++) {
          var item = dataList[i];
          if (item.supplierId !== this.currentSupplierId) {
            item.supplierName = "******";
            item["price_one"] = "竞价结束后公布";
          } else {
           if (this.packs.offerType == "1") {
              item["price_one"] = item.price + "元";
            } else {
              item["price_one"] = (item.price * 100).toFixed(2) + "%";
            }
            this.myData.push(item);
            this.bz = item.bz;
          }
          this.data.push(item);
        }
      }
    },
    successCallback() {
      // 连接成功
      this.stompClient.subscribe("/topic/" + this.packId, this.onMessageReceived);
      this.getProcessList(); //推送数据
    },
    initWebSocket() {
      //初始化websocket操作
      this.socket = new SockJS(this.socketUrl);
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.debug = null; // 关闭浏览器控制台中 日志打印
      this.stompClient.connect(
        {},
        (frame) => {
          this.successCallback(); //连接成功时，回调
        },
        (error) => {
          //连接失败时回调
          console.log(error);
          this.reconnect(this.socketUrl, this.successCallback); // 此处调用重连方法
        }
      );
    },
    reconnect(socketUrl, successCallback) {
      //断开重连使用定时器定时连接服务器
      let connected = false;
      this.reconInv = setInterval(() => {
        this.socket = new SockJS(socketUrl);
        this.stompClient = Stomp.over(this.socket);
        this.stompClient.connect(
          {},
          (frame) => {
            clearInterval(this.reconInv); // 连接成功，清除定时器
            connected = true;
            successCallback();
          },
          (error) => {
            // this.$message.warning("服务重连中,请勿操作!")
            this.sysWarning("服务重连中,请勿操作!");
          }
        );
      }, 5000);
    },
    getProcessList(isEnd) {
      //推送订阅的包件数据
      this.$http
        .get(
          "/api/v1/supplier/socket/get_process_list.json?packsId=" +
            this.packId +
            "&isEnd=" +
            isEnd
        )
        .then(function (res) {
          console.log(res);
        });
    },
    submit() {
      if (this.myData && this.myData.length > 0) {
        this.sysWarning("你已提交报价，不可再次报价");
        return;
      }
      if (this.currentSupplierId != this.$ls.get("user").supplierId) {
        this.sysError("身份异常,无法报价,请刷新页面");
        return;
      }
      if (this.packs.jingjiaDetail == "1" && this.$refs.addSubject.zTotal == 0) {
        this.sysWarning("本包组需填报详情报价");
        return;
      }
      if (this.packs.quotationConfirm == "1") {
        if (this.fileLength == 0 || this.fileLength.length == 0) {
          this.sysWarning("请上传报价确认函");
          return;
        }
      }
      var reg = /(^([1-9]\d*|0)(\.\d+)?$)/;
      var priceNumber =
        this.packs.offerType == "1" ? parseInt(this.myPrice) : parseFloat(this.myPrice);
      var startPrice =
        this.packs.offerType == "1"
          ? parseInt(this.packs.priceStart)
          : parseFloat(this.packs.priceStart);
      if (
        this.myPrice === "" ||
        this.myPrice === null ||
        isNaN(this.myPrice) ||
        priceNumber < 0
      ) {
        this.sysError("报价必须为数值且大于0!");
        return;
      }
      if (this.competeType === "1") {
        //竞高价
        if (priceNumber - startPrice < 0) {
          this.sysError("不得低于于最低限价");
          return;
        }
      } else if (this.competeType === "2") {
        // 竞低价
        if (priceNumber - startPrice > 0) {
          this.sysError("不得高于最高限价");
          return;
        }
      }

      let params = {};
      params.bz = this.bz;
      params.subjectId = "";
      params.competeType = this.packs.jingjiaType;
      params.packId = this.packId;
      params.supplierId = this.currentSupplierId;
      params.price = this.myPrice;
      params.competeNo = this.competeNo;
      params.competeWay = "1";
      this.cmtConfirm(params);
    },
    cmtConfirm(params) {
      //供应商报价确认框
      let that = this;
      const priceText =
        that.packs.offerType == "1"
          ? "报价"
          : that.packs.offerType == "2"
          ? "折扣率"
          : "下浮率";
      this.$confirm({
        title: "您的" +
          priceText +
          "为 " +
          params.price +
          " " +
          (that.packs.offerType == "1" ? "元" : "%") +
          "，您确定要提交吗?",
        okText: "确认提交",
        content: (h) => (
          <div style="color:red;font-size:14px;">
            {" "}
            报价提交后将不可撤回, 请谨慎操作 !{" "}
          </div>
        ),
        onOk() {
          var date =
            new Date(that.stopDate).getTime() - new Date(that.serveDate).getTime();
          if (date < 0) {
            that.$message.info("竞价已结束");
          } else if (that.status === "2") {
            that.$message.info("竞价已结束");
          } else {
            if (that.packs.offerType != "1") {
              params.price = parseFloat(that.myPrice / 100).toFixed(4);
            }
            that.loading = true;
            that.$http
              .post("/api/v1/supplier/socket/cmt_price.json", qs.stringify(params))
              .then(function (res) {
                that.loading = false;
                if (res.code !== 200) {
                  // that.$message.info(res.msg)
                  that.sysError(res.msg);
                }
                // else {
                //     that.getCompeteInfo()
                // }
              });
          }
        },
        onCancel() {},
      });
    },
    onProcess() {
      //初始化进度条
      var common2 =
        new Date(this.commonResultDate).getTime() - new Date(this.serveDate).getTime(); //常规阶段后一段
      if (common2 > 0) {
        //常规阶段
        var commonCount =
          new Date(this.commonResultDate).getTime() - new Date(this.openDate).getTime(); //常规总长度
        this.percent1 = (1 - common2 / commonCount) * 100;
      } else {
        this.percent1 = 100;
        if (this.packs.countDown) {
          //最后阶段
          var lastCount = parseInt(this.packs.countDown) * 60 * 1000; //倒计时总长度
          var last2 =
            new Date(this.stopDate).getTime() - new Date(this.serveDate).getTime(); //最后阶段后一段
          if (last2 > 0) {
            this.percent2 = (1 - last2 / lastCount) * 100;
          } else {
            this.percent2 = 100;
          }
        }
      }
    },
    onSubject() {
      this.bidSubjectVisible = true;
      this.$refs.sbt.initData(this.packId);
    },
    addSubject() {
      this.addSubjectVisible = true;
      this.$refs.addSubject.initData(
        this.packId,
        this.packs.priceStart,
        this.competeType
      );
    },
    uploadSelectorChange(fileLength) {
      if (fileLength) {
        this.fileLength = fileLength;
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
    },
    showSubjectDetail() {
      this.showSubjectVisible = true;
      this.$refs.bidSubjectDetail.initData(this.packId);
    },
    cancel(e, bz) {
      this.bidSubjectVisible = false;
      this.addSubjectVisible = false;
      this.showSubjectVisible = false;
      //详细报价表所需
      if (e != undefined) {
        this.myPrice = e;
      }
      if (bz != undefined) {
        this.bz = bz;
      }
    },
    sysError(content) {
      let secondsToGo = 3;
      const modal = this.$error({
        title: "温馨提示",
        content: content,
      });
      const interval = setInterval(() => {
        secondsToGo -= 1;
        modal.update({
          content: content,
        });
      }, 1000);
      setTimeout(() => {
        clearInterval(interval);
        modal.destroy();
      }, secondsToGo * 1000);
    },
    sysWarning(content) {
      let secondsToGo = 2;
      const modal = this.$warning({
        title: "温馨提示",
        content: content,
        footer: "",
      });
      const interval = setInterval(() => {
        secondsToGo -= 1;
        modal.update({
          content: content,
        });
      }, 1000);
      setTimeout(() => {
        clearInterval(interval);
        modal.destroy();
      }, secondsToGo * 1000);
    },
    back() {
      let projectId = this.$route.query.projectId;
      this.$router.push({
        path: "/compete/PacksList",
        query: { id: projectId },
      });
    },
    openDraw() {
      // this.$refs.draw.initmodel()
      this.$refs.draw.modalVisible = true;
    },
    reSatrtDraw(){
      this.initPacksInfo()
      this.theSame =true
    }
  },
  beforeDestroy() {
    clearInterval(this.serveDateTimer);
    clearInterval(this.countDownTimer);
    clearInterval(this.reconInv);
    this.stompClient.disconnect();
  },
};
</script>

<style lang="less" scoped>
.zjz_c {
  background: #18336a;
  width: 60vw;
  padding: 0.625vw;
  box-sizing: border-box;
  /* 中间的包组信息样式 */
  /deep/ .ant-btn-sm {
    height: 1.25vw;
    padding: 0 0.365vw;
    font-size: 0.729vw;
    border-radius: 0.208vw;
  }
  .t1 {
    padding: 0.521vw;
    width: 100%;
    color: white;
    display: flex;
    justify-content: space-between;
    background: #1d315a;
    border: 0.052vw solid #3c5583;
    margin-bottom: 1.563vw;
    font-size: 0.729vw;
  }

  .t2 {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 1.667vw;

    .box {
      width: 3.229vw;
      height: 2.813vw;
      line-height: 2.813vw;
      text-align: center;
      background: #ebebeb;
      border-radius: 0.208vw;
      color: #000;
      font-size: 1.979vw;
      font-weight: bold;
      box-shadow: inset 0 -1.563vw 0 0 #c8c8c8;
      margin: 0 0.417vw;
    }
  }

  /deep/ .t3 {
    margin-bottom: 0.938vw;

    .ant-progress-inner {
      border-radius: 0;
      overflow: inherit;
    }

    .ant-progress-bg {
      border-radius: 0 !important;
      height: 1.042vw !important;
    }

    .arrow {
      width: 100%;
      max-width: 40.625vw;
      margin: auto;

      .ant-progress-inner {
        background: #e9c376;
      }
    }

    .arrow .ant-progress-bg::before {
      content: "";
      border-top: 0.521vw solid rgba(0, 0, 0, 0);
      border-right: 0.521vw solid rgba(0, 0, 0, 0);
      border-bottom: 0.521vw solid #e9c376;
      border-left: 0.521vw solid rgba(0, 0, 0, 0);
      position: absolute;
      right: -0.521vw;
      top: 0.521vw;
    }

    .arrow.red .ant-progress-inner {
      background: #e97a76;
    }
    .countDown {
      position: absolute;
      right: 29.6vw;
    }
    .countDown.red .ant-progress-inner {
      background: #e97a76;
    }
    .countDown.red .ant-progress-bg::before {
      content: "";
      border-top: 0.521vw solid rgba(0, 0, 0, 0);
      border-right: 0.521vw solid rgba(0, 0, 0, 0);
      border-bottom: 0.521vw solid #e97a76;
      border-left: 0.521vw solid rgba(0, 0, 0, 0);
      position: absolute;
      right: -0.521vw;
      top: 0.521vw;
    }
    .arrow.red .ant-progress-bg::before {
      content: "";
      border-top: 0.521vw solid rgba(0, 0, 0, 0);
      border-right: 0.521vw solid rgba(0, 0, 0, 0);
      border-bottom: 0.521vw solid #e97a76;
      border-left: 0.521vw solid rgba(0, 0, 0, 0);
      position: absolute;
      right: -0.521vw;
      top: 0.521vw;
    }
  }
}

/deep/ .ant-btn {
  height: 2vw;
  padding: 0 0.781vw;
  font-size: 0.729vw;
  line-height: 2vw;
  border: none;
}

.zjz_r {
  background: #132957;
  width: 19.3vw;
  // box-shadow: inset 5px 0 10px 1px rgba(0, 0, 0, 0.2784);
  padding: 0 12px;

  /deep/ .ant-descriptions {
    .ant-descriptions-title {
      color: rgba(255, 255, 255, 0.5);
      margin-bottom: 0.417vw;
      font-size: 0.729vw;
    }
    .ant-descriptions-row > td {
      padding-bottom: 0.417vw;
      font-size: 0.729vw;
    }

    .ant-descriptions-item-label {
      color: #fff;
    }

    .ant-descriptions-item-content {
      color: #fff;
    }
  }

  /deep/ .file_list {
    a {
      span {
        color: #fff !important;
      }
    }

    small {
      color: rgba(255, 255, 255, 0.5) !important;
    }
  }
}

.Operation_area {
  color: #fff;
  .t1 {
    text-align: center;
  }
  .t2 {
    margin-top: 0.625vw;
    display: flex;
    align-items: center;
    /deep/ .ant-input-number {
      width: 100%;
      border: 0.052vw solid #5e6a84;
      height: 3.646vw;
    }
    /deep/ .ant-input-number-input-wrap {
      height: 100%;
      .ant-input-number-input {
        font-size: 2.083vw;
        text-align: center;
        color: #ff0000;
        background: #0b1d41;
        height: 100%;
      }
    }
    .btn {
      padding: 0 0.625vw;
      flex: 0 0 auto;
      font-weight: bold;
      i {
        font-size: 2.083vw;
      }
    }
  }
  .t3 {
    margin: 0.625vw 0 0 0;
    display: flex;
    padding: 0 2vw;
    .ant-btn {
      flex: 1;
      padding: 0;
    }
  }
}

.ant-divider-horizontal {
  margin: 1.25vw 0;
}

.title {
  position: relative;

  img {
    display: block;
    margin: auto;
    width: 15.417vw;
  }

  span {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    top: 1.146vw;
    color: #fff;
    font-size: 1.458vw;
    font-weight: bold;
  }
}

.back-list {
  margin: 0;
  padding: 0.625vw;

  li {
    padding: 0 0.625vw;
    margin-bottom: 0.417vw;
    min-height: 2.604vw;
    display: flex;
    align-items: center;
    background: linear-gradient(90deg, #18336a 0%, rgba(24, 51, 106, 0) 100%);

    &.pack-title-active {
      background: linear-gradient(90deg, #0084ff 0%, rgba(0, 132, 255, 0) 100%);
    }

    &.pack-title {
      cursor: pointer;
    }

    span {
      font-size: 0.938vw;
      color: #ffffff;
      font-weight: bold;
      text-shadow: 0 0.156vw 0 rgba(0, 0, 0, 0.2784);
    }
  }
}

.flex-left {
  padding: 0 10px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

/* 我的竞价编号 */
.code {
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.table-preant {
  width: 100%;
  border: 0.052vw solid #687996;
  background: #132955;
  position: relative;
  height: calc(100vh - 17vw);
  .img {
    position: absolute;
    width: 1.458vw;
    height: 1.458vw;
    &:nth-child(1) {
      left: 0;
      top: 0;
    }
    &:nth-child(2) {
      right: 0;
      top: 0;
      transform: rotate(90deg);
    }
    &:nth-child(3) {
      left: 0;
      bottom: 0;
      transform: rotate(270deg);
    }
    &:nth-child(4) {
      right: 0;
      bottom: 0;
      transform: rotate(180deg);
    }
  }
  .table-preant-item {
    display: flex;
    justify-content: center;
    .table {
      width: 95%;
      color: white;
      .me {
        background: #e97a76;
        border-radius: 0.26vw;
        padding: 0.26vw;
        margin-right: 0.26vw;
      }
      td {
        font-weight: 500;
        margin-bottom: 0.26vw;
        padding: 0.521vw 0;
        text-align: center;
        border-top: 0.208vw solid #132955;
        border-bottom: 0.208vw solid #132955;
        &:nth-child(1) {
          width: 37%;
          text-align: left;
          padding-left: 0.521vw;
        }
        &:nth-child(2) {
          width: 10.417vw;
          text-align: center;
        }
        &:nth-child(3) {
          width: 10.417vw;
          text-align: center;
        }
        &:nth-last-child(1) {
          text-align: right;
          padding-right: 0.521vw;
        }
      }
      thead td {
        color: white;
        padding: 0.521vw 0.781vw;
        border: none;
      }
      tbody {
        tr {
          background: #425477;
        }
        // tr:nth-child(1) td {
        //   background: #60aa46;
        // }
      }
    }
  }
}

/deep/ .ant-descriptions-item,
/deep/ .ant-descriptions-item-content {
  display: flex;
  align-items: center;
}

.scrollbar-zdy {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 100%;
  margin-right: -4px;
}

/*-------滚动条整体样式----*/
.scrollbar-zdy::-webkit-scrollbar {
  width: 4px;
}

/*滚动条里面小方块样式*/
.scrollbar-zdy::-webkit-scrollbar-thumb {
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.2);
}

/*滚动条里面轨道样式*/
.scrollbar-zdy::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
/deep/ .ant-empty {
  margin-top: 10vw;
}
/deep/.ant-empty-description {
  color: red;
}
</style>
